<script>
  import {External, M} from "../../external";

  export let data,
    filter,
    change,
    hasDateInputs = false;

  let currentValue = "";

  $: if (!filter.func) filter.func = "startsWith";

  let onChangeFunction = () => {
    change(filter);
  };

  let onChangeValue = () => {
    if (filter.value !== currentValue) {
      currentValue = filter.value;
      change(filter);
    }
  };

  let executeDate = (node) => {
    const target = External.$(node);
    target
      .datepicker({
        monthNamesShort: [M.JAN, M.FEB, M.MAR, M.APR, M.MAY_SHORT, M.JUN, M.JUL, M.AUG, M.SEP, M.OCT, M.NOV, M.DEC],
        monthNames: [M.JANUARY, M.FEBRUARY, M.MARCH, M.APRIL, M.MAY, M.JUNE, M.JULY, M.AUGUST, M.SEPTEMBER, M.OCTOBER, M.NOVEMBER, M.DECEMBER],
        dateFormat: "dd M, yy",
        onSelect: function (dateText) {
          let date = External.$(this).datepicker("getDate");
          // just get the UTC milliseconds from that date. The calendar sets it to midnight in current timezone...
          filter.value = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
          onChangeValue();
        }
      })
      .datepicker("setDate", new Date());

    if (filter && filter.value && filter.value > 9000) {
      target.datepicker("setDate", new Date(filter.value));
    }

    return {
      destroy: () => {
        target.datepicker("destroy");
      }
    };
  };
</script>

{#each data as item (item)}
  <div class="col20 f-left func-option" class:active={item.func === filter.func} data-role={item.func}>
    <label>
      <input type="radio" name="option" on:change={onChangeFunction} value={item.func} bind:group={filter.func} />
      <span>{item.name}</span>
    </label>
    {#if item.func === filter.func}
      <div class="col20 f-left option-value">
        {#if hasDateInputs}
          <input use:executeDate type="text" name="value" />
        {:else}
          <input type="text" name="value" bind:value={filter.value} on:keyup={onChangeValue} />
        {/if}
      </div>
    {/if}
  </div>
{/each}
